import { classNames } from 'primereact/utils';

type SegmentedControlProps<T extends string> = {
  /** Id of the element that names the group. */
  labelId: string;
  options: readonly { value: T; label: string; className?: string }[];
  value: T;
  onChange: (value: T) => void;
};

/** A row of toggle buttons where exactly one is pressed. */
export const SegmentedControl = <T extends string>({ labelId, options, value, onChange }: SegmentedControlProps<T>) => (
  <div
    role="group"
    aria-labelledby={labelId}
    className="border-theme-border-grey bg-theme-background-grey inline-flex w-fit max-w-full flex-wrap rounded-md border"
  >
    {options.map((option) => {
      const isActive = option.value === value;

      return (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          aria-pressed={isActive}
          className={classNames(
            'focus-visible:outline-fletchers-green-500 cursor-pointer rounded-[4px] px-4 py-1.5 text-sm',
            isActive
              ? 'bg-theme-highlight-green border-theme-border-dark-green text-theme-dark-green border shadow-sm'
              : 'text-theme-black',
            option.className,
          )}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);
